import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

// Sortable answer item
const SortableItem = SortableElement(({ answer }) => (
  <div className="mt-3 mb-3">
    <div>{answer.character.nameOfFamilyMember}</div>
    <div className="d-flex align-items-center gap-2 mt-2">
      <img
        className="answerImage"
        alt="answer"
      />
    </div>
  </div>
));

// Sortable answers list
const SortableAnswers = SortableContainer(({ answers }) => {
  return (
    <div>
      {answers.map((answer, index) => (
        <SortableItem key={`item-${index}`} index={index} answer={answer} />
      ))}
    </div>
  );
});

export default SortableAnswers;
